import { useKeycloak } from "@react-keycloak/web";
import { Avatar, Dropdown } from "antd";
import { Link } from "react-router-dom";
import { useAppDispatch } from "../../../app/store";
import PLACEHOLDER_IMG from "../../../assets/images/avatar.svg";
import { userLoggedOut } from "../../../features/Auth/auth.slice";

export default function ProfileMenu() {
  const dispatch = useAppDispatch();
  const { keycloak } = useKeycloak();

  return (
    <Dropdown
      placement="bottomRight"
      arrow={{ pointAtCenter: true }}
      className="cursor-pointer"
      rootClassName="!left-auto !right-5"
      dropdownRender={() => (
        <ul className="list-none bg-white shadow p-1 rounded">
          {/* <li>
            <Link
              to={"/admin/profile"}
              className="py-1.5 px-8 cursor-pointer select-none text-body hover:text-primary hover:bg-[#FFF5F4] text-sm rounded block"
            >
              My Profile
            </Link>
          </li> */}
          <li
            onClick={() => {
              dispatch(userLoggedOut());
              keycloak.logout();
              localStorage.clear();
            }}
            className="py-1.5 px-8 cursor-pointer select-none text-body hover:text-primary hover:bg-[#FFF5F4] text-sm rounded"
          >
            Logout
          </li>
        </ul>
      )}
    >
      <div className="flex items-center gap-2.5 cursor-pointer">
        <Avatar size={44} src={PLACEHOLDER_IMG} />
      </div>
    </Dropdown>
  );
}
